import { Fingerprint } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "~/shared/ui/button";

import { AssetProvenanceDialog } from "./asset-provenance-dialog";

interface AssetProvenanceActionProps {
    assetId: string;
    workspaceId?: string;
    className?: string;
}

/** Compact action used by both asset cards and generated assets in chat. */
export function AssetProvenanceAction({ assetId, workspaceId, className }: AssetProvenanceActionProps) {
    const { t } = useTranslation("assets");
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button
                type="button"
                variant="ghost"
                size="icon"
                aria-label={t("provenance.open")}
                title={t("provenance.open")}
                className={className ?? "size-7 bg-black/40 text-white hover:bg-black/60"}
                onClick={() => setOpen(true)}
            >
                <Fingerprint className="size-4" aria-hidden />
            </Button>
            <AssetProvenanceDialog
                assetId={assetId}
                workspaceId={workspaceId}
                open={open}
                onOpenChange={setOpen}
            />
        </>
    );
}
